import { render, staticRenderFns } from "./dns.vue?vue&type=template&id=14eee0fa&scoped=true&"
import script from "./dns.vue?vue&type=script&lang=js&"
export * from "./dns.vue?vue&type=script&lang=js&"
import style0 from "./dns.vue?vue&type=style&index=0&id=14eee0fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eee0fa",
  null
  
)

export default component.exports